import FreeUpUsernameHtml    from './admin-dashboard.free-up-username.html';
import GetSupportIdModalHtml from './templates/get_support_id.modal.html';
import NotificationModalHtml from './templates/notification.modal.html';

export function AdminDashboard (
  $uibModal,
  sessionObjAPI,
  workshopAPI
) {
  const AdminDashboard = function() {
    this.$uibModal        = $uibModal;
    this.sessionObjAPI = sessionObjAPI;
    this.workshopAPI   = workshopAPI;
  };

  AdminDashboard.prototype.allowPaymentUpdate = function ( company = {} ) {
    return this.workshopAPI.post('workshop_admin/remove_payment_update_lock', {
      company_id: company.id
    });
  };

  AdminDashboard.prototype.createNotification = function (notification) {
    const self = this;

    return self.submitNotification(notification);
  };

  AdminDashboard.prototype.displayAdvertisement = function () {
    const self     = this;
    const settings = self.sessionObjAPI.systemSettings() || {};

    return !settings.hide_dashboard_ad;
  };

  AdminDashboard.prototype.editNotification = function (notification) {
    const self = this;

    return self.submitNotification(notification);
  };

  AdminDashboard.prototype.freeUpUsername = function () {
    const self = this;

    return self.$uibModal.open({
      controller : 'FreeUpUsernameCtrl',
      templateUrl: FreeUpUsernameHtml
    }).result;
  };

  AdminDashboard.prototype.get_id_for_support = function (company) {
    const self = this;

    return self.$uibModal.open({
      controller : 'GetSupportIDCtrl',
      templateUrl: GetSupportIdModalHtml,
      windowClass: 'lg-modal',
      resolve    : {
        company: () => company
      }
    }).result;
  };

  AdminDashboard.prototype.renameUser = function (username) {
    const self = this;

    return self.workshopAPI.post('/workshop_admin/rename_username_and_log', { username });
  };

  AdminDashboard.prototype.submitNotification = function (notification) {
    const self = this;

    return self.$uibModal.open({
      controller : 'DashboardNotificationCtrl',
      templateUrl: NotificationModalHtml,
      windowClass: 'lg-modal',
      resolve    : {
        notification: () => notification
      }
    }).result;
  };

  return AdminDashboard;
}